import * as React from "react";
import { useParams } from "react-router-dom";
import { extractCourseId } from "../utils";

export default function useCourseId() {
  try {
    const params = useParams<{courseId?: string, course_id?: string}>();
    const courseId = params?.courseId || params?.course_id;
    if(!courseId) {
      throw new Error('no route param')
    }
    return courseId;
  } catch (_) {
    const parsed = React.useMemo(() => extractCourseId(), [document.location.search]);
    return parsed;
  }
}